module.exports = __webpack_public_path__ + "packs/media/images/dummy_icon-4e4aa31ca3537edff41de7a96add2434.jpeg";